// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_cp-3";
export var flatBottomCorners = "_cp-5";
export var productImage = "_cp-0";
export var quantityContainer = "_cp-2";
export var quantityHeader = "_cp-6";
export var tooltip = "_cp-1";
export var wrapAndEllipsesOverflow = "_cp-4";